import React from 'react'

function Register() {
  return (
    <h1>hello</h1>
  )
}

export default Register
